import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">观众评价</h2>
          <p className="text-foreground-600 text-sm">来自真实用户的使用反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.map((comment, idx) => (
            <div key={idx} className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <span className="text-sm font-bold text-accent-700">{comment.name[0]}</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes} 赞</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}